export const BANNER_EXPERIMENT = {
  bannerExperiment: {
    id: 'EXPERT-1712_homepage_remove_banner_for_mobile',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const CHATBOT_EXPERIMENT = {
  chatbotExperiment: {
    id: 'cad-975_chatbot_front_page',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const VERTICAL_COMPARISON_TAB_EXPERIMENT = {
  verticalComparisonTabExperiment: {
    id: 'EXPLAT-1627_homepage_remove_explore_button',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const EXPERIMENTS = {
  ...BANNER_EXPERIMENT,
  ...CHATBOT_EXPERIMENT,
  ...VERTICAL_COMPARISON_TAB_EXPERIMENT,
};
